import { getFullUrl } from 'hubspot-url-utils';
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
export function AppUninstallableMessage({
  uninstallableReason
}) {
  if (!uninstallableReason) return null;
  switch (uninstallableReason.label) {
    case 'NO_COMPATIBLE_FEATURES':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.productDetailsCard.cta.uninstallableReasons.noCompatibleFeatures"
        });
      }
    case 'ALREADY_INSTALLED':
      {
        const urlBase = getFullUrl('app');
        const href = `${urlBase}/integrations-settings/${PortalIdParser.get()}/installed`;
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "detailsPage.productDetailsCard.cta.uninstallableReasons.installed_jsx",
          elements: {
            Link
          },
          options: {
            href,
            external: true
          }
        });
      }
    case 'MISSING_HUB_SCOPES':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "detailsPage.productDetailsCard.cta.uninstallableReasons.missingHubScopes"
      });
    case 'INCOMPATIBLE_INSTALLS':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.productDetailsCard.cta.uninstallableReasons.incompatibleInstalls",
          options: {
            count: uninstallableReason.incompatibleInstalls.length,
            installs: I18n.formatList(uninstallableReason.incompatibleInstalls)
          }
        });
      }
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "detailsPage.productDetailsCard.cta.uninstallableReasons.missingHubUserInstallable"
      });
  }
}